module.exports = __webpack_public_path__ + "img/build_app_obg.6f964970.png";